// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1WtuM","header":"MessagesList_header__10R2J","chat":"MessagesList_chat__1KP66"};